import { Link } from "react-router-dom";

import { ForgotPasswordForm } from "@/features/auth";

export function ForgotPasswordPage() {
  return (
    <div className="grid min-h-screen grid-cols-1 bg-background lg:grid-cols-2">
      <aside className="relative hidden overflow-hidden bg-hero-gradient p-12 text-primary-foreground lg:flex lg:flex-col">
        <div className="absolute inset-0 bg-hero-radial opacity-60" aria-hidden />
        <div className="relative flex h-full w-full max-w-xl flex-col">
          <Link
            to="/"
            className="text-lg font-semibold tracking-display-tight transition-opacity hover:opacity-80"
            aria-label="Go to OneShift home"
          >
            OneShift
          </Link>
          <div className="mt-auto space-y-4">
            <h2 className="text-balance text-4xl font-semibold leading-tight tracking-display-tight">
              Forgot your password?
            </h2>
            <p className="text-base text-white/80">
              Happens to all of us. Drop in the email you signed up with and we'll send you a
              link to set a new one.
            </p>
          </div>
          <p className="relative mt-12 text-xs text-white/60">
            © OneShift · Hosted in Canada · PIPEDA compliant
          </p>
        </div>
      </aside>

      <div className="flex items-center justify-center px-6 py-12 sm:px-10">
        <div className="w-full max-w-md space-y-8">
          <div className="space-y-2 text-center lg:text-left">
            <h1 className="text-3xl font-semibold tracking-display-tight text-copy">
              Reset your password
            </h1>
          </div>

          <ForgotPasswordForm />
        </div>
      </div>
    </div>
  );
}
